import React from "react";

const Groups = () => {
  return <div>SOME GROUP HERE</div>;
};

export default Groups;
